export default __webpack_public_path__ + "static/media/n.978a8bb9.mp3";